<template>
  <div
    class="TimeCom"
    :style="`padding-top: ${changeDevicePixelRatio(20)}px;`"
  >
    <div class="top">
      <div
        class="date"
        :style="`font-size: ${dateFontSize}px;line-height: ${dateFontSize}px;margin-right: ${changeDevicePixelRatio(10)}px;`"
      >{{ systemDate }}</div>
      <div
        class="weather"
        :style="`font-size: ${weatherFontSize}px;line-height: ${weatherFontSize}px;`"
      >
        <div
          class="week"
          :style="`margin-right: ${changeDevicePixelRatio(6)}px;`"
        >{{ weather.week }}</div>
        <div class="tempature">
          {{ weather.tem1 }}°C {{ weather.wea }}
        </div>
      </div>
    </div>
    <div
      class="time"
      :style="`font-size: ${element.style.fontSize}px;line-height: ${element.style.fontSize}px;margin-top: ${changeDevicePixelRatio(10)}px;`"
    >{{ systemTime }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getWeatherOrigin } from '@/api/screen'
import { changeDevicePixelRatio } from '@/utils/changeComponentsSizeWithScale'
import moment from 'moment'
export default {
  components: {},
  props: {
    element: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      weather: {},
      systemDate: '',
      systemTime: ''
    }
  },
  computed: {
    ...mapState({
      projectItem: (state) => state.user.projectItem
    }),
    dateFontSize() {
      const px = Math.ceil(28 / window.devicePixelRatio)
      return px
    },
    weatherFontSize() {
      const px = Math.ceil(18 / window.devicePixelRatio)
      return px
    },
    timeFontSize() {
      const px = Math.ceil(32 / window.devicePixelRatio)
      return px
    }
  },

  mounted() {
    getWeatherOrigin().then((res) => {
      this.weather = res.data
    })
    this.setTime()
    this.timer = setInterval(this.setTime, 1000)
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    changeDevicePixelRatio,
    setTime() {
      this.systemDate = moment().format('YYYY-MM-DD')
      this.systemTime = moment().format('HH:mm:ss')
    }
  }
}
</script>

<style lang="scss" scoped>
.TimeCom {
  width: 380px;
  height: 120px;
  color: #fff;
  padding-top: 20px;
  .top {
    display: flex;
    justify-content: center;
    align-items: baseline;
    .date {
      font-weight: bold;
      margin-right: 10px;
      font-size: 28px;
    }
    .weather {
      font-size: 18px;
      display: flex;
      .week {
        font-weight: bold;
        margin-right: 6px;
      }
      .tempature {
        font-weight: bold;
      }
    }
  }
  .time {
    text-align: center;
    font-weight: bold;
    font-size: 32px;
    margin-top: 10px;
  }
}
</style>
